export const dateFormat = "YYYY-MM-DD";

export const memberStatus = {
    active: "Jemaat Aktif",
    draft: "Calon Jemaat",
    inactive: "Jemaat Tidak Aktif",
    kid: "Sekolah Minggu",
    youth: "Youth",
};
